<template>
  <div class="h-100 pl-3 d-flex align-items-center border-left user-menu">
    <icon
      v-if="false"
      icon="notification"
      class="mr-2 notification-icon"
    />
    <dropdown class="plain">
      <button slot="trigger">
        <span>
          {{ user.name }}
        </span>
      </button>
      <dropdown-option href="/logout">
        Log out
      </dropdown-option>
    </dropdown>
  </div>
</template>

<script>
import Dropdown from '@/components/Dropdown/Dropdown'
import DropdownOption from '@/components/Dropdown/DropdownOption'

export default {
  components: {
    Dropdown,
    DropdownOption,
  },
  props: {
    user: {
      required: true,
      type: Object,
    },
  },
}
</script>
